export default {
  system: {
    user: 'Pengguna',
    level: 'Level',
    earnPerTap: 'Pendapatan per ketukan',
    coinsToLevelUp: 'Koin untuk naik level',
    profitPerHour: 'Keuntungan per jam',
    coming1: 'Sesuatu yang menarik',
    coming2: 'akan segera hadir di sini...',
    close: 'Tutup',
    friends: 'Teman',
    continue: 'Lanjutkan',
  },
  settings: {
    chooseNetwork: 'Pilih jaringan',
    chooseLanguage: 'Pilih bahasa',
  },
  popup_CheckTask: {
    join: 'Bergabung',
    check: 'Periksa',
    taskIsNotCompleted: 'Tugas belum selesai',
  },
  popup_levelUp: {
    levelUp: 'Naik level!',
    multiTap: 'Multi-ketuk',
    energyLimit: 'Batas energi',
  },
  popup_BalanceUp: {
    balanceUp: 'Saldo diperbarui!',
    balanceDiffSinceLast: 'Hadiah Anda',
  },
  popup_BalanceTip: {
    tip: 'Tingkatkan keuntungan Anda',
    message: 'Ketuk menu Tambang untuk membeli peningkatan jaringan Anda',
    description: 'Dapatkan penghasilan bahkan saat offline hingga 3 jam',
  },
  popup_Bored: {
    header: 'Katak bosan!',
    message: 'Bermainlah dengan katak.',
    description: 'Jika katak tidak dimainkan selama 3 jam, keuntungan akan berhenti',
  },
  popup_Hungry: {
    header: 'Katak lapar!',
    message: 'Beri makan katak.',
    description: 'Semakin banyak teman yang Anda miliki, semakin banyak koin yang bisa didapat setiap pemberian makan',
  },
  menu: {
    network: 'Jaringan',
    mine: 'Tambang',
    earn: 'Penghasilan',
    food: 'Makanan',
  },
  tap: {
    bored: 'Bosan',
    fun: 'Seru',
  },
  mineMenu: {
    activities: 'Aktivitas',
    investments: 'Investasi',
    web3: 'WEB3',
    achievements: 'Prestasi',
  },
  leaderboard: {
    from: 'dari',
    beTheFirst: 'Jadilah yang pertama!',
  },
  mine: {
    joinOurTG1: 'Bergabunglah dengan saluran Telegram kami,',
    joinOurTG2: 'untuk membuka!',
    unlock: 'Buka kunci',
  },
  friends: {
    inviteFriends: 'Undang teman!',
    receiveBonuses: 'Anda dan teman Anda akan menerima bonus',
    inviteFriend: 'Undang teman',
    withTelegramPremium: 'dengan Telegram Premium',
    forYouAndYourFriend: 'untuk Anda dan teman Anda',
    moreBonuses: 'Bonus lebih banyak',
    listOfYourFriends: 'Daftar teman Anda',
    linkCopied: 'Tautan undangan telah disalin ke clipboard Anda!',
    playWithMe:
      'Bergabunglah denganku dan bermain untuk mendapatkan token melalui airdrop!\n' +
      '💰 Dapatkan hadiahmu! +3000 koin untuk pendatang baru\n' +
      '🚀 Punya Telegram Premium? Dapatkan +5000 koin!\n',
  },
  earn: {
    moreCoins: 'Dapatkan lebih banyak koin!',
    dailyTasks: 'Tugas harian',
    dailyReward: 'Hadiah harian',
    tasksList: 'Daftar tugas',
    joinOurTG: 'Bergabunglah dengan saluran Telegram kami',
    followOurX: 'Ikuti akun X kami',
    yourAd: 'Iklan Anda bisa ada di sini',
    connect: 'Hubungi admin saluran Telegram kami',
  },
  food: {
    hungry: 'Lapar',
    full: 'Kenyang',
    frogIsFull: 'Katak kenyang',
    feed: 'Beri makan',
    bonus: 'Bonus',
    satiety: 'Kenyang',
    hours: 'jam',
  },
  toast: {
    buyCard: {
      title: 'Pencapaian Terbuka!',
      subtitle: 'Saatnya memimpin kerajaan katak Anda menuju kejayaan 👑',
    },
    feedFrog: {
      title: 'Katak Senang!',
      subtitle: 'Kerja bagus! Beri makan peliharaan Anda agar tetap tersenyum 🍽️',
    },
  },
};
